import Joi from "joi";
import { SendOutPulseSurveyRequest } from "types/feedback-request";

export const sendOutPulseSurveySchema = Joi.object<SendOutPulseSurveyRequest>({
  formId: Joi.number().required().messages({
    "any.required": "Form is required.",
  }),
  dueDate: Joi.date()
    .required()
    .messages({
      "date.base": "Deadline must be a valid date",
      "any.required": "Deadline is required",
    })
    .when("$dueDateChanged", {
      is: Joi.boolean().valid(true).required(),
      then: Joi.date().min(new Date()).messages({
        "date.min": "Deadline must be greater than the current date",
      }),
      otherwise: Joi.any(),
    }),
});
